export default __webpack_public_path__ + "static/media/slide-4-mob.ee5f8305.jpg";